import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "InputDialog",
  props: {
    title: {
      type: String,
      default: "请输入"
    },
    type: {
      type: String,
      default: "text",
      validator: value => ["text", "textarea", "number", "select"].includes(value)
    },
    verifyResult: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: "内容"
    },
    value: {
      type: [String, Number, Array, Object],
      default: ""
    },
    placeholder: {
      type: String,
      default: "请输入内容"
    },
    desc: {
      type: String,
      default: ""
    },
    confirmText: {
      type: String,
      default: "确定"
    },
    cancelText: {
      type: String,
      default: "取消"
    },
    // 是否显示字数统计（Element UI原生功能）
    showWordLimit: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: Number,
      default: null
    },
    rules: {
      type: Array,
      default: () => []
    },
    verify: {
      type: Object,
      default: () => ({
        /*
          label: "活动id",
          showResField: "activityId",
          api: "",
          req: (value) => {
            return { a: value };
          },
        */
      })
    },
    options: {
      type: Array,
      default: () => []
    },
    multiline: {
      type: Boolean,
      default: false
    },
    rows: {
      type: Number,
      default: 4
    },
    width: {
      type: String,
      default: "500px"
    },
    numberMin: {
      type: Number,
      default: -Infinity
    },
    numberMax: {
      type: Number,
      default: Infinity
    },
    numberStep: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      res: {},
      dialogVisible: false,
      form: {
        value: this.value || "3"
      },
      loading: false,
      error: "",
      resolve: null,
      reject: null
    };
  },
  computed: {
    isRequired() {
      return this.rules.some(rule => rule.required);
    }
  },
  watch: {
    value: {
      handler(newVal) {
        console.log("newVal", newVal);
        this.form.value = newVal;
      },
      deep: true,
      immediate: true
    },
    "form.value"() {
      this.error = "";
    }
  },
  create() {
    var _this$verify;
    if (this.value && (_this$verify = this.verify) !== null && _this$verify !== void 0 && _this$verify.resName) {
      this.doVerify();
    }
  },
  methods: {
    open() {
      console.log("this.value", this.value);
      this.dialogVisible = true;
      this.form.value = this.value;
      this.error = "";
      this.loading = false;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    inputBlur() {
      this.doVerify();
    },
    async doVerify() {
      if (this.verify.api) {
        const params = this.verify.req(this.form.value);
        const res = await this.verify.api(params);
        if (res.status === 200) {
          this.res = res.data;
        } else {
          console.log("验证出错了", res);
        }
      }
    },
    handleConfirm() {
      // 验证输入
      if (this.rules.length > 0) {
        const validationError = this.validateInput(this.form.value);
        if (validationError) {
          this.error = validationError;
          return;
        }
      }
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.dialogVisible = false;
        if (this.resolve) {
          console.log(111);
          this.resolve(this.form.value);
        }
      }, 0);
    },
    handleCancel() {
      this.dialogVisible = false;
      if (this.reject) {
        this.reject(new Error("用户取消输入"));
      }
    },
    validateInput(value) {
      for (const rule of this.rules) {
        if (rule.required && (value === "" || value === null || value === undefined)) {
          return rule.message || "该项为必填项";
        }
        if (rule.pattern && !rule.pattern.test(value)) {
          return rule.message || "格式不正确";
        }
        if (rule.validator && typeof rule.validator === "function") {
          const result = rule.validator(value);
          if (result !== true) {
            return result || "验证失败";
          }
        }
        if (rule.min !== undefined && value < rule.min) {
          return rule.message || `值不能小于 ${rule.min}`;
        }
        if (rule.max !== undefined && value > rule.max) {
          return rule.message || `值不能大于 ${rule.max}`;
        }
      }
      return "";
    }
  }
};